import axios from "axios"

export default {
    async getProducts(dataOptions, search) {
        var url = `ntr/product/counts?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if (search != '')
            url = `${url}&search=${search}`
        if (dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    },
    async addProd(data) {
        return await axios.post('ntr/product/', data)
            .then(result => result.data)
            .catch(error => Promise.reject(error));
    },
    async addStock(data) {
        console.log(data)
        return await axios.put('ntr/product/stock', data)
        .then(result => result.data)
        .catch( error => Promise.reject(error));
    },
    async addOrder(data) {
        return await axios.post('/order', data)
            .then(result => result.data)
            .catch(error => Promise.reject(error));
    },
    async getfarmProducts(dataOptions, search, id) {
        var url = `ntr/product/?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}&farm=${id}`
        if (search != '')
            url = `${url}&search=${search}`
        if (dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    },
    async getProductOrders(id, dataOptions, search) {
        var url = `ntr/product/ordered/${id}?page=${dataOptions.page}&limit=${dataOptions.itemsPerPage}`
        if (search != '')
            url = `${url}&search=${search}`
        if (dataOptions.sortBy.length)
            url = `${url}&col=${dataOptions.sortBy[0]}&desc=${dataOptions.sortDesc[0]}`
        return axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    },
    async getOrderDetails(id) {
        var url = `order/${id}`
        return await axios.get(url)
            .then(({ data }) => data)
            .catch(error => Promise.reject(error));
    },
    async updateStatus(data) {
        var url = `order/status`
        return await axios.put(url, data)
            .then((result) => result.data)
            .catch(error => Promise.reject(error));
    },
}